import { render } from "./FloatingChatButton.vue?vue&type=template&id=0127c263"
import script from "./FloatingChatButton.vue?vue&type=script&lang=js"
export * from "./FloatingChatButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__